<div *ngIf="active" class="circle-loader" [class.full-screen]="fullScreen">
    <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
</div>
